export default function scrollToTop(): Promise<void> {
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  });

  return Promise.resolve();
}
